export default {
  NoStatement: 'NoStatement',
  InStatement: 'InStatement',
  StatementSent: 'StatementSent',
  StatementPaid: 'StatementPaid'
}
